import LockScroll from 'utils/LockScroll'
import debounce from 'utils/debounce';
import BreakpointSniffer from 'utils/BreakpointSniffer'

export default (function() {
	let $openButton;
	let $closeButton;
	let $modal;
	let isOpen = false;
	let isLarge = false;
	let currentUrl;

	function init() {
		$openButton = $('.js-open-configurator');
		$closeButton = $('.js-close-configurator');
		$modal = $('.js-configurator-modal');

		$openButton.click(open);
		$closeButton.click(close);

		isLarge = BreakpointSniffer.isBigger('lg');
		$(window).on('resize', debounce(onResize));
		onResize();

		currentUrl = new URL(window.location.href);

		reset();
		currentUrl.hash = '';
		history.replaceState({isOpen}, null, currentUrl.toString());

		window.addEventListener('popstate', (e) => {
			if (!isLarge && e.state !== null) {
				if (e.state.isOpen) {
					open(null, false);
				} else {
					close(null, false);
				}
			}
		});
	}

	function onResize() {
		if (BreakpointSniffer.isBigger('lg') && !isLarge) {
			reset();
			isLarge = true;
		} else if (!BreakpointSniffer.isBigger('lg') && isLarge) {
			isLarge = false;
		}
	}

	function open(e = null, setState = true) {
		if (e) {
			e.preventDefault();
		}

		$modal.show();
		isOpen = true;
		$('body').addClass('modal-open');
		LockScroll.lock();

		if (setState) {
			currentUrl.hash = '#configure';
			history.pushState({isOpen}, null, currentUrl.toString());
		}
	}

	function close(e = null, setState = true) {
		if (e) {
			e.preventDefault();
		}

		$modal.hide();
		isOpen = false;
		$('body').removeClass('modal-open');
		LockScroll.unlock();

		if (setState) {
			currentUrl.hash = '';
			history.pushState({isOpen}, null, currentUrl.toString());
			console.log('setting state!');
		}
	}

	function reset() {
		if (isOpen) {
			close(null, false);
		}

		$modal.css('display', '');
	}

	return {
		init
	};
})();